var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonSocialProviders = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M18.378 11.57H5.34a1.34 1.34 0 010-2.68h13.038a1.34 1.34 0 010 2.68zM18.378 16.457H5.34a1.34 1.34 0 010-2.68h13.038a1.34 1.34 0 010 2.68z", fill: fills.base }),
        React.createElement("path", { d: "M8.602 21.348a1.34 1.34 0 01-1.332-1.487l1.628-14.67a1.34 1.34 0 012.662.296l-1.63 14.67a1.339 1.339 0 01-1.328 1.191zM13.49 21.348a1.34 1.34 0 01-1.332-1.487l1.631-14.67a1.34 1.34 0 012.662.296l-1.631 14.67a1.34 1.34 0 01-1.33 1.191z", fill: fills.base }),
        React.createElement("path", { d: "M17.507 43.691l-5.689-4.065-5.688 4.066a.714.714 0 01-1.13-.58V28.523c0-1.076.871-1.948 1.948-1.948h9.74c1.077 0 1.948.872 1.948 1.948v14.588c0 .58-.656.92-1.13.58zM42.54 5.457a4.982 4.982 0 00-7.04 0l-.96.96-.867-.866c-1.912-1.915-5.035-2.062-7.01-.213a4.978 4.978 0 00-.122 7.16l.96.96 6.666 6.666a.532.532 0 00.752 0l6.666-6.666.963-.963a4.981 4.981 0 00-.008-7.038z", fill: fills.dark }),
        React.createElement("path", { d: "M36.436 30.901v-3.735a2.803 2.803 0 00-2.803-2.804l-3.736 8.408v10.94h10.787c.932.01 1.73-.667 1.869-1.589l1.29-9.072a1.868 1.868 0 00-1.87-2.148h-5.537z", fill: fills.light }),
        React.createElement("path", { d: "M29.897 43.71h-3.488a1.87 1.87 0 01-1.869-1.87v-7.203c0-1.03.836-1.87 1.87-1.87h3.487", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
